import React from 'react'
import { SanitizedHTML } from '@labsavvyapp/ui-components'
import style from './LabReportResultCategory.module.css'

export default function LabReportResultCategory({ children, name, subtitle, summary, image, style: outStyle }) {
  return (
    <div className={style.container} style={outStyle}>
      <div className={style.category}>
        <div className={style.leftColumn}>
          <h2>{name}</h2>
          {image ? <img alt="Icon" className={style.categoryImage} src={image} /> : null}
        </div>
        <div className={style.rightColumn}>
          <h2>Reference Range</h2>
          <h2>Result</h2>
        </div>
      </div>
      {subtitle || summary ? (
        <div className={style.categoryInfo}>
          {subtitle ? <h3>{subtitle}</h3> : null}
          {summary ? (
            <p>
              <SanitizedHTML text={summary} />
            </p>
          ) : null}
        </div>
      ) : null}

      <div>{children}</div>
    </div>
  )
}
